export const ItemTypes = {
  CARD: "card",
  BOX: "box",
};
